<template>
  <div class="delete-account-modal-content">
    <h1 class="header">
      {{
        `By submitting a request for ${$appName} to delete your
      account, you understand and acknowledge that:`
      }}
    </h1>

    <ul class="flex list-disc flex-col gap-5 pl-5">
      <li v-for="(item, index) in listItems" :key="index">
        <div class="flex flex-col gap-1">
          <span
            class="font-secondary text-size_4 font-semibold text-neutral-800"
          >
            <span>{{ item.title }}</span>
          </span>
          <span
            v-if="item.description"
            class="font-secondary text-size_4 font-light text-neutral-800"
          >
            {{ item.description }}
          </span>
        </div>
      </li>
    </ul>

    <p class="font-secondary text-size_4 font-light text-neutral-900">
      Please note that account deletion requests are usually attended
      <span class="font-secondary text-size_4 font-semibold text-neutral-900">
        within 30 days.</span
      >
    </p>

    <div
      v-if="showCheckbox"
      class="rounded-xl border-[0.5px] border-action bg-primary-0 p-4"
    >
      <Checkbox
        v-model="confirmationChecked"
        label="I understand and accept the terms and I'm willing to delete this account."
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import Checkbox from "~/components/common/Atom/Checkbox.vue";

defineProps<{
  showCheckbox: boolean;
}>();

const confirmationChecked = defineModel("confirmation-checked", {
  default: false,
});

const nuxtApp = useNuxtApp();

const listItems = [
  {
    title: `You will lose all personal details you shared with ${nuxtApp.$appName}.`,
    description: "",
  },
  {
    title:
      "You will lose all past transaction details, saved addresses, payment methods,..etc.",
    description: "",
  },
  {
    title:
      "Any individual account associated with this admin account will be subsequently deleted.",
    description: "",
  },
];
</script>

<style scoped>
.delete-account-modal-content {
  @apply flex flex-col gap-8;

  .header {
    @apply font-secondary text-size_4 font-light text-neutral-900;
  }
}
</style>
